import type { ReactNode } from "react";
import { ModuleProvider } from "@/context/ModuleContext";
import { useModulesQuery } from "@/hooks/admin/useModules";

// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------

interface AdminModuleProviderProps {
  readonly children: ReactNode;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export default function AdminModuleProvider({
  children,
}: AdminModuleProviderProps) {
  const { data, isLoading } = useModulesQuery();

  return (
    <ModuleProvider modules={data ?? []} isLoading={isLoading}>
      {children}
    </ModuleProvider>
  );
}
